<div class="container-fluid px-0 text-dark">
  <div class="d-none d-lg-block w-100">
    <div class="row justify-content-between align-items-center " style="padding: 20px 20px 20px 60px">
        <div class="col">
        <img width="60px" src="assets/images/jata-mufti-160h.png" alt=""> &nbsp;
        <img width="250px" src="assets/images/eFalak-01.png" alt="">
        </div>
        <div class="col text-end">
          <!-- routerLink="/auth" -->
            <a class="btn btn-primary" (click)="checkMantainance()">
              Log Masuk
              @if(loading){
                &nbsp;
                <div class="spinner-grow spinner-grow-sm" role="status">
                    <span class="sr-only"></span>
                </div> 
              }
            </a>
        </div>
    </div>
  </div>
    <div class="d-block d-lg-none">
    <div class="row justify-content-between align-items-center w-100" style="padding: 14px 0px 14px 0px">
        <div class="col-10">
        <img width="45px" src="assets/images/jata-mufti-160h.png" alt=""> &nbsp;
        <img width="200px" src="assets/images/eFalak-01.png" alt="">
        </div>
        <div class="col-2 text-end">
            <!-- <a class="btn btn-primary" (click)="login()" >Log Masuk</a> -->
            <i class="ti ti-user-circle" style="font-size: 30px; cursor: pointer;" (click)="checkMantainance()"></i>
        </div>
    </div>
    </div>
      
        <div class="marquee">
          @if(announcements){
              <marquee behavior="scroll" style="margin-top: 8px;">{{announcements}}</marquee >
          }
        </div>
    
    
        <app-map></app-map>
  
      
    <div class="row justify-content-between align-items-center m-0 kiblat-section" >
     
        <div class="col-12 col-md-6 p-0">
            <div class="row justify-content-center align-items-center">
                <div class="col-12 ">
                  <span class="date font-20" style="font-weight: 700;">
                    Tarikh: {{tarikh_masihi}} | {{tarikh_hijri}}
                  </span>
                </div>
                <div class="col-12 ">
                  <span class="font-20" style="font-weight: 700;">Waktu Solat</span>
                </div>
                @if(prayerTime && nextPrayer){
                <div class="col-12 " style="margin-top: 24px">
                  <span>Waktu solat seterusnya: {{nextPrayer}}</span>
                    <p style="font-size: 22px; font-weight: 600; color: #000;">{{ countdown }}</p>
                </div>
                }
                <div class="col-12 ml-3" style="margin-top: -16px;">
                  <div class="row prayer-time ">
                      <!-- <p style="font-weight: 700;">Waktu Solat</p> -->
                    <div class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-2 mb-2 ">
                      <!-- <img src="assets/images/prayer-logo/fajr.png" width="50px" alt=""> -->
                      <br>
                      Subuh <br> {{ prayerTime ? prayerTime.fajr.substring(0, 5) : '06:12'}}
                    </div>
                    <div class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-2 mb-2 ">
                      <!-- <img src="assets/images/prayer-logo/fajr.png" width="50px" alt=""> -->
                      <br>
                      Syuruk <br> {{ prayerTime ? prayerTime.syuruk.substring(0, 5) : '07:22'}}
                    </div>
                    <div class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-2 mb-2 ">
                      <!-- <img src="assets/images/prayer-logo/dhuhr.png" width="50px" alt=""> -->
                      <br>
                      Zohor <br> {{ prayerTime ? prayerTime.dhuhr.substring(0, 5) : '13:25'}}
                    </div>
                    <div class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-2 mb-2 ">
                      <!-- <img src="assets/images/prayer-logo/asr.png" width="50px" alt=""> -->
                      <br>
                      Asar <br> {{ prayerTime ? prayerTime.asr.substring(0, 5) : '16:47'}}
                    </div>
                    <div class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-2 mb-2 ">
                      <!-- <img src="assets/images/prayer-logo/maghrib.png" width="50px" alt=""> -->
                      <br>
                      Maghrib <br> {{ prayerTime ? prayerTime.maghrib.substring(0, 5) : '19:22'}}
                    </div>
                    <div class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-2 mb-2 ">
                      <!-- <img src="assets/images/prayer-logo/isha.png" width="50px" alt=""> -->
                      <br>
                      Isyak <br> {{ prayerTime ? prayerTime.isha.substring(0, 5) : '20:36'}}
                    </div>
                  </div>
                  <form [formGroup]="reactiveForm" class="ml-3">
                  <div class="row justify-content-center ">
                    <select formControlName="zon" class="form-control" id="choices-single-no-sorting"
                      (change)="onSubmit()" data-choices data-choices-sorting-false >
                      <option disabled selected value="">Tukar Lokasi</option>
                      @for (item of locationList; track $index) {
                        <option [value]="item.code">{{item.zone}}</option>
                      }
                      <!-- <option value="SGR01">SGR01 - Gombak, Petaling, Sepang, Hulu Langat, Hulu Selangor, S.Alam</option>
                      <option value="SGR02">SGR02 - Kuala Selangor, Sabak Bernam</option>
                      <option value="JHR01">JHR01 - Pulau Aur dan Pulau Pemanggil</option>
                      <option value="JHR02">JHR02 - Johor Bahru, Kota Tinggi, Mersing, Kulai</option>
                      <option value="JHR03">JHR03 - Kluang, Pontian</option>
                      <option value="JHR04">JHR04 - Batu Pahat, Muar, Segamat, Gemas Johor, Tangkak</option>
                      <option value="KDH01">KDH01 - Kota Setar, Kubang Pasu, Pokok Sena (Daerah Kecil)</option>
                      <option value="KDH02">KDH02 - Kuala Muda, Yan, Pendang</option>
                      <option value="KDH03">KDH03 - Padang Terap, Sik</option>
                      <option value="KDH04">KDH04 - Baling</option>
                      <option value="KDH05">KDH05 - Bandar Baharu, Kulim</option>
                      <option value="KDH06">KDH06 - Langkawi</option>
                      <option value="KDH07">KDH07 - Puncak Gunung Jerai</option>
                      <option value="KTN01">KTN01 - Bachok, Kota Bharu, Machang, Pasir Mas, Pasir Puteh, Tanah Merah, Tumpat, Kuala Krai, Mukim Chiku</option>
                      <option value="KTN02">KTN02 - Gua Musang (Daerah Galas Dan Bertam), Jeli, Jajahan Kecil Lojing</option>
                      <option value="MLK01">MLK01 - SELURUH NEGERI MELAKA</option>
                      <option value="NGS01">NGS01 - Tampin, Jempol</option>
                      <option value="NGS02">NGS02 - Jelebu, Kuala Pilah, Rembau</option>
                      <option value="NGS03">NGS03 - Port Dickson, Seremban</option>
                      <option value="PHG01">PHG01 - Pulau Tioman</option>
                      <option value="PHG02">PHG02 - Kuantan, Pekan, Rompin, Muadzam Shah</option>
                      <option value="PHG03">PHG03 - Jerantut, Temerloh, Maran, Bera, Chenor, Jengka</option>
                      <option value="PHG04">PHG04 - Bentong, Lipis, Raub</option>
                      <option value="PHG05">PHG05 - Genting Sempah, Janda Baik, Bukit Tinggi</option>
                      <option value="PHG06">PHG06 - Cameron Highlands, Genting Higlands, Bukit Fraser</option>
                      <option value="PLS01">PLS01 - Kangar, Padang Besar, Arau</option>
                      <option value="PNG01">PNG01 - Seluruh Negeri Pulau Pinang</option>
                      <option value="PRK01">PRK01 - Tapah, Slim River, Tanjung Malim</option>
                      <option value="PRK02">PRK02 - Kuala Kangsar, Sg. Siput , Ipoh, Batu Gajah, Kampar</option>
                      <option value="PRK03">PRK03 - Lenggong, Pengkalan Hulu, Grik</option>
                      <option value="PRK04">PRK04 - Temengor, Belum</option>
                      <option value="PRK05">PRK05 - Kg Gajah, Teluk Intan, Bagan Datuk, Seri Iskandar, Beruas, Parit, Lumut, Sitiawan, Pulau Pangkor</option>
                      <option value="PRK06">PRK06 - Selama, Taiping, Bagan Serai, Parit Buntar</option>
                      <option value="PRK07">PRK07 - Bukit Larut</option>
                      <option value="SBH01">SBH01 - Bahagian Sandakan (Timur), Bukit Garam, Semawang, Temanggong, Tambisan, Bandar Sandakan, Sukau</option>
                      <option value="SBH02">SBH02 - Beluran, Telupid, Pinangah, Terusan, Kuamut, Bahagian Sandakan (Barat)</option>
                      <option value="SBH03">SBH03 - Lahad Datu, Silabukan, Kunak, Sahabat, Semporna, Tungku, Bahagian Tawau (Timur)</option>
                      <option value="SBH04">SBH04 - Bandar Tawau, Balong, Merotai, Kalabakan, Bahagian Tawau (Barat)</option>
                      <option value="SBH05">SBH05 - Kudat, Kota Marudu, Pitas, Pulau Banggi, Bahagian Kudat</option>
                      <option value="SBH06">SBH06 - Gunung Kinabalu</option>
                      <option value="SBH07">SBH07 - Kota Kinabalu, Ranau, Kota Belud, Tuaran, Penampang, Papar, Putatan, Bahagian Pantai Barat</option>
                      <option value="SBH08">SBH08 - Pensiangan, Keningau, Tambunan, Nabawan, Bahagian Pendalaman (Atas)</option>
                      <option value="SBH09">SBH09 - Beaufort, Kuala Penyu, Sipitang, Tenom, Long Pasia, Membakut, Weston, Bahagian Pendalaman (Bawah)</option>
                      <option value="SGR03">SGR03 - Klang, Kuala Langat</option>
                      <option value="SWK01">SWK01 - Limbang, Lawas, Sundar, Trusan</option>
                      <option value="SWK02">SWK02 - Miri, Niah, Bekenu, Sibuti, Marudi</option>
                      <option value="SWK03">SWK03 - Pandan, Belaga, Suai, Tatau, Sebauh, Bintulu</option>
                      <option value="SWK04">SWK04 - Sibu, Mukah, Dalat, Song, Igan, Oya, Balingian, Kanowit, Kapit</option>
                      <option value="SWK05">SWK05 - Sarikei, Matu, Julau, Rajang, Daro, Bintangor, Belawai</option>
                      <option value="SWK06">SWK06 - Lubok Antu, Sri Aman, Roban, Debak, Kabong, Lingga, Engkelili, Betong, Spaoh, Pusa, Saratok</option>
                      <option value="SWK07">SWK07 - Serian, Simunjan, Samarahan, Sebuyau, Meludam</option>
                      <option value="SWK08">SWK08 - Kuching, Bau, Lundu, Sematan</option>
                      <option value="SWK09">SWK09 - Zon Khas (Kampung Patarikan)</option>
                      <option value="TRG01">TRG01 - Kuala Terengganu, Marang, Kuala Nerus</option>
                      <option value="TRG02">TRG02 - Besut, Setiu</option>
                      <option value="TRG03">TRG03 - Hulu Terengganu</option>
                      <option value="TRG04">TRG04 - Dungun, Kemaman</option>
                      <option value="WLY01">WLY01 - Kuala Lumpur, Putrajaya</option>
                      <option value="WLY02">WLY02 - Labuan</option> -->
                    </select>
                  </div>
                </form>
    
                </div>
                <div class="col-12 mt-3 mt-md-4">
                  <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                    <ngb-carousel class="carousel-inner" role="listbox">
                      @for (pengumuman of pengumumans; track $index) {
                        <ng-template ngbSlide class="carousel-item active">
                          @if(pengumuman.url){
                            <a target="_blank" href="{{ pengumuman.url }}">
                              <img class="d-block img-fluid image-slider" [src]="pengumuman.gambar" alt="Slide">
                            </a>
                          }@else{
                            <img class="d-block img-fluid image-slider" [src]="pengumuman.gambar" alt="Slide">
                          }
                        </ng-template>
                      }
                    </ngb-carousel> 
                </div>
                </div>
              </div>
            </div>
        <div class="col-12 col-md-6 align-items-center mt-3">
          <div class="row justify-content-center  mb-3">
            <div class="info-card text-dark" >
                <div class="row align-items-center">
                  <div class="col-3 text-center">
                    <img width="70px" src="assets/images/Arah kiblat.png" alt="">
                  </div>
                  <div class="col-9">
                    <p style="font-weight: 700; font-size: 20px;">Permohonan Arah Kiblat</p>
                    <span style="font-size: 16px; text-transform: justify;">Untuk mendapatkan penanda arah kiblat serta mengesahkan kesahihan arah kiblat di lokasi. Pengesahan ini penting bagi memastikan ketepatan arah kiblat selaras dengan ketetapan syariah. </span>
                  </div>
                </div>
            </div>
          </div>
          <div class="row justify-content-center  mb-3">
            <div class="info-card text-dark" >
                <div class="row align-items-center">
                  <div class="col-3 text-center">
                    <img width="70px" src="assets/images/Azimut kiblat.png" alt="">
                  </div>
                  <div class="col-9">
                    <p style="font-weight: 700; font-size: 20px;">Permohonan Azimut Kiblat</p>
                    <span style="font-size: 16px;  text-transform: justify;"> Untuk mendapatkan pengesahan azimut kiblat bagi pihak arkitek sebelum pembinaan, bagi memastikan reka bentuk bangunan, khususnya ruang solat, mematuhi ketetapan syariah.  </span>

                   
                  </div>
                </div>
            </div>
          </div>
          <div class="row  justify-content-center  mb-3">
            <div class="info-card text-dark" >
                <div class="row align-items-center">
                  <div class="col-3 text-center">
                    <img width="70px" src="assets/images/Balai cerap.png" alt="">
                  </div>
                  <div class="col-9">
                    <p style="font-weight: 700; font-size: 20px;">Permohonan Lawatan ke Balai Cerap</p>
                    <span style="font-size: 16px;  text-transform: justify;">Kebenaran untuk mengadakan lawatan ke balai cerap bagi tujuan pembelajaran dan pendedahan kepada ilmu falak serta astronomi. </span>
                  </div>
                </div>
            </div>
          </div>
        </div>
    </div>
    
    <!-- <div class="div-bg" >
      <div  st>
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col-12 col-md-4  ">
            <h3>Jabatan Mufti Negeri Selangor</h3> 
            Tingkat 7 & 8, Menara Utara,Bangunan <br>
            Sultan Idris Shah, 40000 Shah Alam, <br>
          Selangor Darul Ehsan
          </div>
          <div class="col-12 col-md-4  ">
            <h3>Hubungi Kam</h3> 
            Telefon: 03-55143739<br>
            Fax: 03-55197584<br>
            Emel: mail&#64;muftiselangor.gov.my
          </div>
          <div class="col-12 col-md-4  ">
            <h3>Pelawat</h3> 
            Hari Ini: 89<br>
            Minggu Ini: 457<br>
            Jumlah Pelawat: 2357
          </div>
        </div> 
      </div>
      <div class="text-center" style="margin-top: 20px;">
        Jabatan Mufti Selangor. Hakcipta Terpelihara 2025
      </div>
    </div> -->
    
    <div class="footer-section text-dark div-bg">
      <div class="container py-4">
        <div class="row">
          <div class="col-md-4">
            <p style="font-size: 20px; font-weight: 700; margin-bottom: 10px;">Jabatan Mufti Negeri Selangor</p>
            <p style="font-size: 16px;">
              Tingkat 7 & 8, Menara Utara<br>
              Bangunan Sultan Idris Shah,<br>
              40000 Shah Alam,<br>
              Selangor Darul Ehsan.
            </p>
          </div>
          <div class="col-md-4">
            <p style="font-size: 20px; font-weight: 700; margin-bottom: 10px;">Hubungi Kami</p>
            <p style="font-size: 16px;">
              Telefon: 03-55143739<br>
              Fax: 03-55197584<br>
              Email: mail&#64;muftiselangor.gov.my
            </p>
          </div>
          <div class="col-md-4">
            <p style="font-size: 20px; font-weight: 700; margin-bottom: 10px;">Pelawat</p>
            <p style="font-size: 16px;">
              Hari Ini: {{visitorCount?.todayVisitorsCount}}<br>
              Minggu Ini: {{visitorCount?.weekVisitorsCount}}<br>
              Jumlah Pelawat: {{visitorCount?.total_visitor}}
            </p>
          </div>
        </div>
        <div class="text-center" style="margin-top: 40px; font-size: 16px;">
          Jabatan Mufti Negeri Selangor. Hakcipta Terpelihara 2025
        </div>
      </div>
    </div>
    
</div>
